export const SET_KITHCENS = 'SET_KITHCENS';
export const SET_SELECTED = 'SET_SELECTED';
